import React from "react";

export default function Collection() {
  return (
    <div className="advertiSec">
      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            <div className="adverItem">
              <div className="adverimge">
                {/* <img src="assets/images/adverimge1.jpg" alt="" /> */}
                <img src={`${process.env.PUBLIC_URL}/assets/images/adverimge1.jpg`} alt="" />
              </div>
              <div className="advertitle pagehding">
                <h2>
                  Summer <br /> Collections
                </h2>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="adverItem">
              <div className="adverimge">
                {/* <img src="assets/images/adverimge2.jpg" alt="" /> */}
                <img src={`${process.env.PUBLIC_URL}/assets/images/adverimge2.jpg`} alt="" />
              </div>
              <div className="advertitle pagehding">
                <h2>
                  pearl necklace <br /> and earrings
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
